import { Button } from "@/components/ui/button/button";

import { RecurringPurchaseSwitchSection } from "./recurring-purchase-switch-section";

import type { ComponentProps } from "react";

type RecurringPurchaseDialogContentProps = {
	ticketListComponent: () => JSX.Element;
	isStopRecurringProBilling: boolean;
	onUpdateIsStopRecurringProBilling: () => void;
	isValid: boolean;
	onUpdate: () => Promise<void>;
};

export const RecurringPurchaseDialogContent = ({
	ticketListComponent,
	isStopRecurringProBilling,
	onUpdateIsStopRecurringProBilling,
	isValid,
	onUpdate,
}: RecurringPurchaseDialogContentProps) => {
	const variant: ComponentProps<typeof Button>["variant"] = isValid ? "default" : "disabled";

	return (
		<div className="space-y-8">
			<div className="space-y-1 text-sm">
				<p>定額チケットを定期購入すると、選択中のチケットが自動更新されます。</p>
				<p>予約手数料は「宿泊日」ではなく「予約日」に計算されるため、</p>
				<p>繁忙期の予約が入り始める時期に、定額課金に切り替えることをお勧めします。</p>
			</div>

			{ticketListComponent()}

			<RecurringPurchaseSwitchSection
				isStopRecurringProBilling={isStopRecurringProBilling}
				onUpdateIsStopRecurringProBilling={onUpdateIsStopRecurringProBilling}
			/>

			<div className="flex justify-end">
				<Button variant={variant} size="xl" onClick={onUpdate}>
					更新
				</Button>
			</div>
		</div>
	);
};

RecurringPurchaseDialogContent.displayName = "RecurringPurchaseDialogContent";
